import { mobile, tablet, desktop, wideScreen } from './breakpoints';
var queries = {
    isMobile: "screen and (max-width: " + mobile.max + "px)",
    isTablet: "screen and (min-width: " + tablet.min + "px) and (max-width: " + tablet.max + "px)",
    isDesktop: "screen and (min-width: " + desktop.min + "px)",
    isWideScreen: "screen and (min-width: " + wideScreen.min + "px)",
};
var defaultValues = {
    mobile: {
        width: 320,
        type: 'screen',
    },
    tablet: {
        width: tablet.min,
        type: 'screen',
    },
    desktop: {
        width: desktop.min,
        type: 'screen',
    },
    wideScreen: {
        width: wideScreen.min,
        type: 'screen',
    },
};
export default queries;
export { defaultValues };
